<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="标签批次" prop="LabelBatch">
                <el-input size="small" v-model="model.LabelBatch" auto-complete="off" placeholder="请输入标签批次"
                    maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="标签供应商" prop="LableSupplier">
                <el-input size="small" v-model="model.LableSupplier" auto-complete="off" placeholder="请输入标签供应商"
                    maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="标签订单号" prop="BatchOrderNo">
                <el-input size="small" v-model="model.BatchOrderNo" auto-complete="off" placeholder="请输入标签订单号"
                    maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-upload class="upload-demo" action="" :on-change="handleDownloadUrlChange"
                    :http-request="handleHttpRequestDownload" :on-exceed="handleDownloadOver" :limit="limitDownload"
                    :file-list="fileDownloadUrlList" accept=".txt">
                    <el-button size="small" type="primary" style="padding:12px 20px;font-size:14px;margin-right:10px">导入标签
                    </el-button>
                    <span slot="tip" class="el-upload__tip">只能上传.txt文件类型</span>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        AddLableBatch,
        UploadLableDetail
    } from '../../api/tag'
    export default {
        data() {
            return {
                title: '添加标签',
                name: 'add',
                labelwidth: '150px',
                labelPosition: 'right',
                limitDownload: 1,
                fileDownloadUrlList: [],
                baseURL: window.Global.baseURL,
                model: {
                    LabelBatch: null,
                    LableSupplier: '',
                    BatchOrderNo: '',
                },
                rules: {
                    LabelBatch: [{
                        required: true,
                        message: '请输入标签批次',
                        trigger: 'blur'
                    }],
                    LableSupplier: [{
                        required: true,
                        message: '请输入标签供应商',
                        trigger: 'blur'
                    }],
                    BatchOrderNo: [{
                        required: true,
                        message: '请输入标签订单号',
                        trigger: 'blur'
                    }],
                },

            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            }
        },

        methods: {
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.AddLableBatch()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });

            },
            handleClose() {
                this.$emit('closeAddDialog')
            },
            AddLableBatch() {
                AddLableBatch(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            handleHttpRequestDownload(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                formdata.append('LabelBatch', this.model.LabelBatch)
                UploadLableDetail(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.GetLableDetailInfo();
                    }
                })
            },
            handleDownloadOver() {
                this.$message({
                    message: '只能上传一个文件',
                    type: 'error'
                });
            },
            handleDownloadUrlChange(file, fileList) {
                this.fileDownloadUrlList = fileList.slice(-1);
            },
            handleDeleteAll() {
                if (!this.selectList.length) {
                    this.$message({
                        message: '请先选择要删除的数据',
                        type: 'warning'
                    });
                    return false;
                }
            },
        }
    }
</script>

<style>

</style>